// extracted by mini-css-extract-plugin
export var base = "typography-module--base--caba1";
export var blockQuote = "typography-module--blockQuote--ff22d";
export var large = "typography-module--large--cbea7";
export var macro = "typography-module--macro--8b14a";
export var micro = "typography-module--micro--e1f62";
export var paragraph = "typography-module--paragraph--fe41f";
export var responsiveTitle1 = "typography-module--responsiveTitle1--64e79";
export var responsiveTitle2 = "typography-module--responsiveTitle2--c92cd";
export var responsiveTitle2Orig = "typography-module--responsiveTitle2Orig--6543d";
export var responsiveTitle3 = "typography-module--responsiveTitle3--bf7fe";
export var responsiveTitle4 = "typography-module--responsiveTitle4--cff8b";
export var responsiveTitle5 = "typography-module--responsiveTitle5--94449";
export var responsiveTitleHuge = "typography-module--responsiveTitleHuge--4c361";
export var small = "typography-module--small--089fc";
export var title1 = "typography-module--title1--a1613";
export var title2 = "typography-module--title2--6e3d1";
export var title3 = "typography-module--title3--27d01";